module.exports = {"importing":"Probíhá import subjektů do skupiny "}